import { render, staticRenderFns } from "./PublishersProducts.component.vue?vue&type=template&id=6f8c4a7a&scoped=true"
import script from "./PublishersProducts.component.vue?vue&type=script&lang=js"
export * from "./PublishersProducts.component.vue?vue&type=script&lang=js"
import style0 from "./PublishersProducts.component.vue?vue&type=style&index=0&id=6f8c4a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8c4a7a",
  null
  
)

export default component.exports